// IndexedDB schema migrations. Phase 3 Step 5 (2/4).
//
// All DDL (store / index creation, future restructures) goes here so the
// `upgrade` callback in db.ts stays a one-liner. When DB_VERSION bumps,
// add the new branch below — do not branch in db.ts.

import type { IDBPDatabase } from 'idb';

import type { RenavoraSchema } from './db.js';

/**
 * Apply schema migrations from `oldVersion` to `newVersion`. Called by idb's
 * `upgrade` callback during openDB() when the on-disk DB version is below
 * DB_VERSION.
 *
 * Add future branches as `if (oldVersion < N) { … }` blocks in order, so a
 * first-time install at version K runs every prior branch in sequence.
 */
export function runMigrations(
  db: IDBPDatabase<RenavoraSchema>,
  oldVersion: number,
  _newVersion: number | null,
): void {
  // v0 → v1: create `characters` store + `byUpdatedAt` index.
  if (oldVersion < 1) {
    const store = db.createObjectStore('characters', { keyPath: 'id' });
    store.createIndex('byUpdatedAt', 'updatedAt');
  }

  // Future: v1 → v2 etc. should slot in here as additional `if (oldVersion < N)` blocks.
}
